import React from "react";
import PageLayout from "../../components/PageLayout";
import OBHavingTroubleCard from "../onboarding/_components/OBHavingTroubleCard";
import ViewProfileMainWrapper from "./components/ViewProfileMainWrapper";

function ViewProfileMain() {
  return (
    <PageLayout>
      <section className="d-flex flex-1xl-nowrap flex-column flex-wrap flex-xl-row align-items-start gap-3 product-listing-main-wrapper-section">
        <ViewProfileMainWrapper />
        {/* <OBHavingTroubleCard /> */}
      </section>
    </PageLayout>
  );
}

export default ViewProfileMain;
